import { Link } from "react-router-dom";
import { Instagram, Youtube, Music2, Rss } from "lucide-react";
import { PLATFORM_LINKS } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#2E4959] text-white mt-24 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 opacity-10 jt-grain" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/logo.jpg" alt="Jesus Talk" className="h-11 w-11 rounded-full ring-1 ring-white/20" />
            <span className="font-display text-3xl text-[#F4E4C1] tracking-widest">JESUS TALK</span>
          </div>
          <p className="text-white/75 max-w-md leading-relaxed">
            Un média chrétien né d'une vision reçue de Dieu — pour développer ta vie spirituelle et ta relation avec Jésus à travers podcasts et contenus qui parlent vrai.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-[#C99A5B] mb-4">Site</h4>
          <ul className="space-y-2 text-white/80 text-sm">
            <li><Link to="/" className="hover:text-white">Accueil</Link></li>
            <li><Link to="/podcasts" className="hover:text-white">Podcasts</Link></li>
            <li><Link to="/a-propos" className="hover:text-white">À propos</Link></li>
            <li><Link to="/ministere" className="hover:text-white">Ministère</Link></li>
            <li><Link to="/temoignages" className="hover:text-white">Témoignages</Link></li>
            <li><Link to="/ressources" className="hover:text-white">Nourris ta foi</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-[#C99A5B] mb-4">Écoutez-nous</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={PLATFORM_LINKS.spotify} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/80 hover:text-white"><Music2 className="w-4 h-4" /> Spotify</a></li>
            <li><a href={PLATFORM_LINKS.youtube} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/80 hover:text-white"><Youtube className="w-4 h-4" /> YouTube</a></li>
            <li><a href={PLATFORM_LINKS.rss} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/80 hover:text-white"><Rss className="w-4 h-4" /> RSS</a></li>
            <li><a href="https://www.instagram.com/jesus___talk" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/80 hover:text-white"><Instagram className="w-4 h-4" /> Instagram</a></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} Jesus Talk — Tous droits réservés</p>
          <p className="italic font-serif">« Ta parole est une lampe à mes pieds » — Psaume 119:105</p>
        </div>
      </div>
    </footer>
  );
}
